import { render } from "./decidedStatus.vue?vue&type=template&id=674e1ee6"
import script from "./decidedStatus.vue?vue&type=script&lang=js"
export * from "./decidedStatus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__